enum AccessReportsProductDefaultElementsEnum {
  AccessStandard = "standard",
  CalculationMethod = "calculationMethod",
  DistanceMethod = "distanceMethod",
  Product = "product",
  ProductType = "productType",
  ReportTitleOne = "reportTitleOne",
  ReportTitleThree = "reportTitleThree",
  ReportTitleTwo = "reportTitleTwo",
}

export { AccessReportsProductDefaultElementsEnum };
